import { render } from "./ConsultaPedidoResultado.vue?vue&type=template&id=7af4924e&scoped=true"
import script from "./ConsultaPedidoResultado.vue?vue&type=script&lang=js"
export * from "./ConsultaPedidoResultado.vue?vue&type=script&lang=js"

import "./ConsultaPedidoResultado.vue?vue&type=style&index=0&id=7af4924e&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7af4924e"]])

export default __exports__